export default "__VITE_ASSET__DuWGSxi0__"